<template>

<div class="mbh-actionplan" v-if="data">

	<div class="mbh-intro" v-if="data.intro" v-html="data.intro"></div>

	<div class="mbh-actionplan-hcp" v-if="hasHcpSteps">

		<div class="mbh-actionplan-section-title">{{ data.hcp_title || 'Your health professional indicated these are the next steps' }}</div>

		<div class="mbh-actionplan-hcp-item" v-for="(step, index) in hcpSteps" :key="index">
			<i class="fa-solid fa-check"></i>
			<span>{{ step }}</span>
		</div>

	</div>

	<div class="mbh-actionplan-self">

		<div class="mbh-actionplan-section-title">{{ data.self_title || 'I am going to:' }}</div>

		<div class="mbh-actionplan-self-intro" v-if="data.self_intro" v-html="data.self_intro"></div>

		<div class="mbh-actionplan-goals">

			<div class="mbh-actionplan-goal" v-for="goal in activeGoals" :key="goal.key" v-on:click="toggleGoal(goal.key)" :class="{'is-active': isGoalActive(goal.key)}">
				<div class="mbh-actionplan-goal-check"><i class="fa-solid fa-check" v-if="isGoalActive(goal.key)"></i></div>
				<span v-html="parseText(goal.text)"></span>
			</div>

		</div>

	</div>

	<div class="mbh-actionplan-foot">
		<button class="mbh-save-button" :class="{'is-disabled': !goals.length}" v-on:click="goals.length && onSave()">Save</button>
	</div>

</div>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return { goals: [] }

	},

	computed: {

		activeGoals: function() {

			return this.$_.filter(this.data.goals || [], function(goal) { return goal.text })

		},

		hasHcpSteps: function() {

			return this.$store.getters['session/patient/mode'] === 'prepopulated' && this.hcpSteps.length > 0

		},

		hcpSteps: function() {

			var steps = []
			var values = this.$store.getters['session/values']

			var medicineOptions = {
				1: 'Consider starting an oral bisphosphonate',
				2: 'Consider starting hormone replacement therapy (HRT)',
				3: 'No drug recommended',
				4: 'Continue with an oral bisphosphonate',
				5: 'Stop current treatment with an oral bisphosphonate',
				6: 'Stop current treatment with an oral bisphosphonate and consider an alternative drug in primary care'
			}

			if (values[100] && medicineOptions[values[100]]) steps.push(medicineOptions[values[100]])
			if (values[101] === 1) steps.push('Onwards referral for opinion or scans')
			if (values[101] === 2) steps.push('No onwards referral')

			var referralFor = values[102]
			if (referralFor && referralFor.length) {
				var opts = { 1: 'Bone density scan', 2: 'Specialist advice and guidance', 3: 'Specialist referral' }
				var items = []
				this.$_.each(referralFor, function(v) { if (opts[v]) items.push(opts[v]) })
				if (items.length) steps.push('Referral for: ' + items.join(', '))
			}

			var nextSteps = values[103] || []
			if (this.$_.contains(nextSteps, 1)) steps.push('No further action needed \u2013 unless any further concerns')
			if (this.$_.contains(nextSteps, 2)) steps.push('Collect prescription for new osteoporosis medicine from pharmacy')

			var awaitItems = values[105] || []
			if (this.$_.contains(nextSteps, 3) && awaitItems.length) {
				var awaitOpts = { 1: 'next appointment', 2: 'hospital appointment', 3: 'physiotherapy appointment', 4: 'blood test' }
				var awaitTexts = []
				this.$_.each(awaitItems, function(v) { if (awaitOpts[v]) awaitTexts.push(awaitOpts[v]) })
				if (awaitTexts.length) steps.push('Await: ' + awaitTexts.join(', '))
			}

			var bookItems = values[106] || []
			if (this.$_.contains(nextSteps, 4) && bookItems.length) {
				var bookOpts = { 1: 'next appointment', 2: 'physiotherapy appointment', 3: 'blood test', 4: 'further contact' }
				var bookTexts = []
				this.$_.each(bookItems, function(v) { if (bookOpts[v]) bookTexts.push(bookOpts[v]) })
				if (bookTexts.length) steps.push('Book: ' + bookTexts.join(', '))
			}

			return steps

		}

	},

	created: function() {

		var saved = localStorage.getItem('ifrap_patient_goals')
		if (saved) this.goals = JSON.parse(saved)
		if (this.goals.length) this.$emit('complete')

	},

	methods: {

		parseText: function(text) {

			if (!text) return ''
			return text.replace(/\[url=([^\]]+)\](.*?)\[\/url\]/g, '<a href="$1" target="_blank" class="mbh-actionplan-link">$2</a>')

		},

		toggleGoal: function(key) {

			var index = this.goals.indexOf(key)
			if (index >= 0) { this.goals.splice(index, 1) } else { this.goals.push(key) }
			localStorage.setItem('ifrap_patient_goals', JSON.stringify(this.goals))
			if (this.goals.length) this.$emit('complete')

		},

		isGoalActive: function(key) { return this.goals.indexOf(key) >= 0 },

		onSave: function() {

			localStorage.setItem('ifrap_patient_goals', JSON.stringify(this.goals))
			if (this.goals.length) this.$emit('complete')
			this.$emit('close')

		}

	}

}

</script>

<style>

.mbh-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 24px; font-weight: 300; }
.mbh-actionplan-section-title { font-size: 20px; font-weight: 600; color: #343434; text-transform: uppercase; margin-bottom: 20px; }
.mbh-actionplan-hcp { margin-bottom: 32px; padding-bottom: 32px; border-bottom: 1px solid var(--aid-color); }
.mbh-actionplan-hcp-item { display: flex; align-items: flex-start; padding: 8px 0; font-size: 16px; color: #343434; line-height: 24px; }
.mbh-actionplan-hcp-item i { color: #4CAF50; margin-right: 12px; margin-top: 4px; flex-shrink: 0; }
.mbh-actionplan-self { margin-bottom: 16px; }
.mbh-actionplan-self-intro { font-size: 16px; color: #666; line-height: 24px; margin-bottom: 20px; }
.mbh-actionplan-goals { display: flex; flex-direction: column; }

.mbh-actionplan-goal {
	display: flex; align-items: center; padding: 14px 16px;
	border: 2px solid #e0e0e0; border-radius: 12px; margin-bottom: 8px;
	cursor: pointer; font-size: 16px; color: #343434; line-height: 22px;
	background-color: #fff; transition: all 300ms ease-in-out;
}

.mbh-actionplan-goal:hover { border-color: var(--aid-color); }
.mbh-actionplan-goal.is-active { border-color: #343434; background-color: #343434; color: #fff; }

.mbh-actionplan-goal-check {
	width: 24px; height: 24px; flex-shrink: 0; margin-right: 12px;
	border-radius: 4px; border: 2px solid #ccc;
	display: flex; align-items: center; justify-content: center;
	font-size: 12px; color: transparent;
}

.mbh-actionplan-goal.is-active .mbh-actionplan-goal-check { border-color: #fff; background-color: #343434; color: #fff; }

.mbh-actionplan-link {
	color: inherit;
	font-weight: 600;
	text-decoration: underline;
	text-decoration-color: var(--aid-color);
	text-underline-offset: 3px;
	text-decoration-thickness: 2px;
}

.mbh-actionplan-goal.is-active .mbh-actionplan-link { text-decoration-color: #fff; }

.mbh-actionplan-foot { display: flex; justify-content: center; margin-top: 16px; }

</style>
